import(/* webpackMode: "eager", webpackExports: ["SmartStackFeed"] */ "/vercel/path0/components/resources/SmartStackClient.tsx");
